import { render, staticRenderFns } from "./new.vehicle.vue?vue&type=template&id=cf740d88"
import script from "./new.vehicle.vue?vue&type=script&lang=js"
export * from "./new.vehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports